import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "pi pi-pencil edit-icon kn-flex" }, null, -1)
const _hoisted_3 = { class: "p-mr-2" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-pencil edit-icon" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_component_DataTable, {
    class: "p-datatable-sm kn-table p-m-2",
    value: _ctx.inputColumns,
    editMode: "cell",
    dataKey: _ctx.functionsCatalogDatasetFormColumnsTableDescriptor.dataKey,
    responsiveLayout: _ctx.functionsCatalogDatasetFormColumnsTableDescriptor.responsiveLayout,
    breakpoint: _ctx.functionsCatalogDatasetFormColumnsTableDescriptor.breakpoint,
    onCellEditComplete: _ctx.onCellEditComplete
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        class: "kn-truncated",
        field: "name",
        header: _ctx.$t('managers.functionsCatalog.inputColumnName')
      }, null, 8, ["header"]),
      _createVNode(_component_Column, {
        class: "kn-truncated",
        field: "type",
        header: _ctx.$t('common.type')
      }, {
        body: _withCtx((slotProps) => [
          _createVNode("i", {
            class: _ctx.getIconClass(slotProps.data.type)
          }, null, 2),
          _createTextVNode(" " + _toDisplayString(slotProps.data.type), 1)
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        header: _ctx.$t('managers.functionsCatalog.datasetColumn')
      }, {
        editor: _withCtx((slotProps) => [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_Dropdown, {
              style: _ctx.functionsCatalogDatasetFormColumnsTableDescriptor.dropdownStyle,
              class: "p-mr-2 kn-flex",
              modelValue: slotProps.data['dsColumn'],
              "onUpdate:modelValue": ($event: any) => (slotProps.data['dsColumn'] = $event),
              options: _ctx.datasetColumns
            }, null, 8, ["style", "modelValue", "onUpdate:modelValue", "options"]),
            _hoisted_2
          ])
        ]),
        body: _withCtx((slotProps) => [
          _createVNode("span", _hoisted_3, _toDisplayString(slotProps.data['dsColumn']), 1),
          _hoisted_4
        ]),
        _: 1
      }, 8, ["header"])
    ]),
    _: 1
  }, 8, ["value", "dataKey", "responsiveLayout", "breakpoint", "onCellEditComplete"]))
}